import {Component, OnInit, TemplateRef} from '@angular/core';
import {Translatable} from "../../../../../Translatable";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {ActivatedRoute} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {environment} from "../../../../../../environments/environment";
import * as $ from "jquery";
import {valuesys} from "../../../../../../options";
import Swal from "sweetalert2";
import {tarif} from "../../../../model/db";

@Component({
  selector: 'app-tarif',
  templateUrl: './tarif.component.html',
  styleUrls: ['./tarif.component.css']
})
export class TarifComponent extends Translatable implements OnInit {

  title:string ;
  dtOptions: DataTables.Settings = {};

  titleModal:string ;
  //titleProfilage:string=this.__('profil.profils') ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  modalRef: BsModalRef;




  public tarifs:tarif [] = [];


  public tarif:tarif  = new tarif();
  tarif_error: tarif;
  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService
  ) {
    super();
  }
  async ngOnInit() {
    this.auth.initAutority("TAR");

    this.isAdd = true ;
    this.isValid = false ;
    this.title = this.__("lebel_users");
    this.initDatatable()
    //console.log(" liste des droits "+this.listeModules);


  }

  initDatatable(){
    this.dtOptions = this.helper.dataTableOption();
    this.dtOptions.columns = [
      {data:"value"},
      {data:"label"},
      {data:"activite"},
    ]  ;
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.http
        .get<DataTablesResponse>(
          environment.tarif +"?"+  $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
        ).subscribe(resp => {
        this.tarifs = resp.data;
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }



  async addUserForm(){
    this.isValid = true ;
    if(this.isAdd ){
      console.log(this.tarif);
      let res =  await this.http.post<any>( environment.tarif,this.tarif,valuesys.httpAuthOptions()).toPromise();
      console.log("ree",res)
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
        //this.rerender();
        this.tarifs.push(res.data);
        this.close()
      }else if(res.code === 400){
        this.tarif_error = <tarif> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
    }else if(res.code === 500){
        let msg = this.__("msg.warningA")
        this.toastr.warning(msg, this.__("msg.warning"));
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }else {
      console.log("Tarif update",this.tarif);
        let res =  await this.http.put<any>( environment.tarif + '/'+this.tarif.id,this.tarif,valuesys.httpAuthOptions()).toPromise();
      console.log("res tarif",res);
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
        this.close()
      }else if(res.code === 400){
        this.tarif_error = <tarif> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }
    this.isValid = false ;

  }
  async openModal(template: TemplateRef<any>,currenTarif:tarif =null,btn:any) {
    btn.disabled= true
    this.tarif_error = new tarif();
    if(currenTarif == null){
      this.tarif = new tarif();
      this.isAdd = true ;
      this.titleModal = this.__('tarif.add') ;
    }else {
      this.isAdd = false ;
      this.titleModal = this.__('tarif.edit') ;
      let res = await this.http.get<any>(environment.tarif + '/' + currenTarif.id,valuesys.httpAuthOptions()).toPromise();
      console.log("res.tarifopenMoale",res);
      this.tarif = currenTarif ;
      console.log("this.tarifopenMoale",this.tarif);

    }
    btn.disabled= false

    this.modalRef = this.modalService.show(template,{ignoreBackdropClick:true});
  }
  close(){
    this.tarif_error = new tarif();
    this.tarif = new tarif();
    this.titleModal = "" ;
    this.modalRef.hide()
  }
  delete(deleteTarif:tarif,btn:any){
    btn.disabled= true
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed_delete'),
      cancelButtonText: this.__('msg.cancel_delete')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.delete<any>(environment.tarif+"/"+deleteTarif.id,valuesys.httpAuthOptions()).toPromise();
        if(sup.code == 204){
          this.tarifs= this.tarifs.filter(function (item,index) {
            return item.id != deleteTarif.id
          });
          btn.disabled= false
          Swal.fire(
            this.__('msg.deleted'),
            sup.msg,
            'success'
          )
        }else {
          btn.disabled= false
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          this.__('msg.canceled'),
          this.__('msg.canceled_delete'),
          'error'
        )
        btn.disabled= false
      }
    })
  }


  async toggleState(type:tarif,state:number,btn:any){
    console.log(btn.hidden = true)
    $(btn).attr('disabled');
    btn.disabled = true;
    let toogle = await this.http.get<any>( environment.tarif+`/${type.id}/${state}/state`,valuesys.httpAuthOptions()).toPromise();
    if(toogle.code == 201){
      this.toastr.success(toogle.msg,this.__("msg.success"));
      type.state = toogle.data.state

    }else {
      this.toastr.error(toogle.msg,this.__("msg.error"));
    }
    btn.disabled = false;
  }


}

